// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v1-monitoring[data-v-8883a074]{display:flex;flex-direction:column;align-items:center;width:100%}.v1-monitoring p[data-v-8883a074]{max-width:900px}.v1-monitoring .btn[data-v-8883a074]{min-width:200px}", ""]);
// Exports
module.exports = exports;
